export const RotationConfigurationPermissions = {
  ViewRotationConfiguration :  {
    components: null ,  
    componentsId: null , 
    permissionsId: 'e158d881-0a94-4ded-db0a-08dbf16cf01d' , 
    permissionsName: 'View Rotation Configuration'  ,  
  }
};
